import React, { useRef, useEffect, useState } from "react";
import SplitType from "split-type";
import gsap from "gsap";

export const Skills = ({ showSkills, setShowSkills }) => {
  const skillsListLeft = [
    {
      image: "/images/expressjs-icon.svg",
      name: "ExpressJS",
    },

    {
      image: "/images/node_logo.svg",
      name: "Node JS",
    },
    {
      image: "/images/next_logo.svg",
      name: "Next JS",
    },
    {
      image: "/images/postgresql_logo.svg",
      name: "PostgreSQL",
    },
    {
      image: "/images/typescript_logo.svg",
      name: "Typescript",
    },
    {
      image: "/images/react_logo.svg",
      name: "React JS",
    },
  ];

  const skillsListRight = [
    {
      image: "/images/three_logo.svg",
      name: "Three JS",
    },
    {
      image: "/images/tailwind_logo.svg",
      name: "TailwindCSS",
    },
    {
      image: "/images/webflow_logo.svg",
      name: "Webflow",
    },
    {
      image: "/images/framer_logo.svg",
      name: "Framer",
    },
    {
      image: "/images/webgl.svg",
      name: "WebGL",
    },
    {
      image: "/images/opengl.svg",
      name: "OpenGL",
    },
  ];

  const allSkills = [
    {
      image: "/images/expressjs-icon.svg",
      name: "ExpressJS",
    },

    {
      image: "/images/node_logo.svg",
      name: "Node JS",
    },
    {
      image: "/images/next_logo.svg",
      name: "Next JS",
    },
    {
      image: "/images/postgresql_logo.svg",
      name: "PostgreSQL",
    },
    {
      image: "/images/typescript_logo.svg",
      name: "Typescript",
    },
    {
      image: "/images/react_logo.svg",
      name: "React Js",
    },
    {
      image: "/images/three_logo.svg",
      name: "Three Js",
    },
    {
      image: "/images/tailwind_logo.svg",
      name: "Tailwind css",
    },
    {
      image: "/images/webflow_logo.svg",
      name: "Webflow",
    },
    {
      image: "/images/framer_logo.svg",
      name: "Framer",
    },
  ];
  const [hoveredSkill, setHoveredSkill] = useState("");
  const splitRef = useRef(null);

  const animateText = () => {
    if (splitRef.current) {
      splitRef.current.revert();
    }

    splitRef.current = new SplitType(".our-text", { types: "chars" });
    const chars = splitRef.current.chars;

    gsap.fromTo(
      chars,
      {
        opacity: 0,
        yPercent: 80,
        scaleY: 2.3,
        scaleX: 0.7,
        transformOrigin: "50% 0%",
      },
      {
        duration: 0.8,
        ease: "back.inOut(3)",
        opacity: 1,
        yPercent: 0,
        scaleY: 1,
        scaleX: 1,
        stagger: 0.03,
      }
    );
  };

  useEffect(() => {
    if (hoveredSkill !== "") {
      animateText();
    }

    return () => {
      if (splitRef.current) {
        splitRef.current.revert();
      }
      gsap.killTweensOf(".our-text");
    };
  }, [hoveredSkill]);

  const handleMobileSkillClick = (skillName) => {
    if (hoveredSkill === skillName) {
      setHoveredSkill("");
    } else {
      setHoveredSkill(skillName);
    }
  };

  return (
    <>
      <div
        className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2
        w-full text-center items-center justify-center z-30 font-raleway md:text-[100px] text-[48px] our-text font-thin pointer-events-none"
      >
        {hoveredSkill !== "" && hoveredSkill}
      </div>
      {/* {showSkills === "show" && ( */}
      <div className="absolute top-0 w-full h-full left-0 z-10 show-skills pointer-events-none">
        <div className="relative flex items-center w-full h-full  justify-center panel orange flex-horizontalScroll  font-semibold font-[raleway] ">
          {/* <div
              onClick={() => {
                setShowSkills("hide");
              }}
              className="absolute close-button top-10 right-10 border border-1 rounded-full p-4 bg-white z-20 text-black cursor-pointer"
            >
              X
            </div> */}
          {/* <p className="z-20">My Skills</p> */}
          <div className="absolute w-screen md:h-screen h-[100dvh] bottom-[0px] left-0 text-lg pointer-events-none lg:px-[100px]">
            <div className="hidden md:flex items-center justify-between w-full grid-cols-10 h-full ">
              {/* <div className="col-span-2"></div> */}
              <div
                className="flex items-center "
                //  className="bg-gradient-to-r from-white via-[#cccccc] to-transparent bg-opacity-10"
              >
                <div className="flex flex-col h-fit gap-24 w-full justify-center lg:pl-[0px] text-2xl text-white pointer-events-none z-10 py-12 ">
                  {skillsListLeft.map((each, i) => (
                    <div className="relative pointer-events-auto">
                      <img
                        onMouseEnter={() => {
                          setHoveredSkill(skillsListLeft[i].name);
                        }}
                        onMouseLeave={() => {
                          setHoveredSkill("");
                        }}
                        className="2xl:w-16 lg:w-12 w-8 hover:scale-[1.5] transition-all cursor-pointer"
                        src={skillsListLeft[i].image}
                      ></img>
                    </div>
                  ))}
                </div>
              </div>

              <div
                className=""
                // className=" bg-gradient-to-l from-black via-[#121212] to-transparent"
              >
                <div className="flex flex-col h-fit gap-24 w-full justify-center items-end pr-[0px] text-2xl text-white z-10 py-12 pointer-events-none">
                  {skillsListRight.map((each, i) => (
                    <div className="relative pointer-events-auto ">
                      <img
                        onMouseEnter={() => {
                          setHoveredSkill(skillsListRight[i].name);
                        }}
                        onMouseLeave={() => {
                          setHoveredSkill("");
                        }}
                        className="2xl:w-16 lg:w-12 w-8 hover:scale-[1.5] transition-all cursor-pointer"
                        src={skillsListRight[i].image}
                      ></img>
                    </div>
                  ))}
                </div>
              </div>
              {/* <div className="col-span-2"></div> */}
            </div>
            <div className="md:hidden flex flex-col justify-between w-screen h-[100dvh]">
              <div className="bg-gradient-to-b from-black via-[#121212] to-transparent pt-20">
                <div className="flex md:flex-col flex-row h-full gap-12 lg:gap-16 w-full justify-center items-center text-2xl text-white pointer-events-auto">
                  {skillsListLeft.map((each, i) => (
                    <div
                      key={i}
                      className="relative items-center justify-center"
                    >
                      <img
                        onTouchStart={() => handleMobileSkillClick(each.name)}
                        onTouchEnd={() => setTimeout(() => {
                          handleMobileSkillClick("")
                        }, 1200)}
                        className="w-8 hover:scale-[1.5] transition-all cursor-pointer"
                        src={each.image}
                        alt={each.name}
                      />
                    </div>
                  ))}
                </div>
              </div>

              <div className="bg-gradient-to-t from-black via-[#121212] to-transparent">
                <div className="flex h-full gap-12 lg:gap-16 w-full justify-center items-center pb-32 text-2xl text-white pointer-events-auto">
                  {skillsListRight.map((each, i) => (
                    <div
                      key={i}
                      className="relative items-center justify-center"
                    >
                      <img
                        onTouchStart={() => handleMobileSkillClick(each.name)}
                        onTouchEnd={() => setTimeout(() => {
                          handleMobileSkillClick("")
                        }, 1200)}
                        className="w-8 hover:scale-[1.5] transition-all cursor-pointer"
                        src={each.image}
                        alt={each.name}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* )} */}
    </>
  );
};
